// آیدی‌ها معادل id سکشن‌های صفحه هستن (برای اسکرول‌اسپای)
export const navLinks = [
  { id: "/", label: "خانه", href: "/" },
  { id: "/about", label: "درباره ما", href: "/about" },
  //   { id: "/contact", label: "راه های ارتباطی", href: "/contact" },

  //   { id: "/services", label: "خدمات", href: "/services" },
  //   { id: "/portfolio", label: "نمونه‌کارها", href: "/portfolio" },
  { id: "/contact", label: "تماس با ما", href: "/contact" },
  { id: "/faq", label: "سوالات متداول", href: "/faq" },
  { id: "/blog", label: "بلاگ", href: "/blog" },
];

// زیرمجموعه‌ای که در نوار پایین موبایل نمایش داده می‌شه
export const bottomNavLinks = [navLinks[0], navLinks[1], navLinks[2]];